import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    error: [],
    loading: false,
    data: false
};

const slice = createSlice({
    name: "homeData",
    initialState,
    reducers: {
        HomeDataRequest: (homeData) => {
            homeData.loading = true;
            homeData.error = false;
        },
        HomeDataClear: (homeData) => {
            homeData.error = false;
            homeData.loading = false;
        },
        HomeDataSuccess: (homeData, action) => {
            homeData.loading = false;
            homeData.error = false;
            homeData.data = action.payload;
        },
        HomeDataError: (homeData, action) => {
            homeData.loading = false;
            homeData.error = action.payload;
        }
    }
});

export const { HomeDataClear, HomeDataRequest, HomeDataSuccess, HomeDataError } = slice.actions;

export default slice.reducer;
